const Logger = (state: any) => (next: any) => (action: any) => {
    //console.log('STORE-ACTION', action);
    return next(action);
};

export default Logger;